/**
 * J-04h：產品顯示標籤。多數產品名稱就是代碼，重複顯示沒有資訊；顏色才是辨認依據。
 * 名稱跟代碼一樣（或空白）時只顯示代碼，名稱不同時才加；有顏色就接「 · 顏色」。
 */
type ProductLike = { code: string; name?: string | null; color?: string | null };

/** 代碼後面要接的說明（名稱與顏色）；沒有可補充的就是空字串。 */
export function formatProductDetail(product: ProductLike): string {
  const name = product.name?.trim();
  const color = product.color?.trim();
  const parts = [name && name !== product.code ? name : "", color ? `· ${color}` : ""].filter(Boolean);
  return parts.join(" ");
}

export function formatProductLabel(product: ProductLike): string {
  const detail = formatProductDetail(product);
  return detail ? `${product.code} ${detail}` : product.code;
}
